/* global videojs */
export const playerOptions = {
    //playbackRates: [0.5, 1, 1.5, 2],
    preload: 'auto',
    responsive: true,
    suppressNotSupportedError: true,
    inactivityTimeout: 4000,
    fluid: true,
    preferFullWindow: videojs.browser.IS_IOS,
    html5: {
        nativeTextTracks: videojs.browser.IS_IOS,
        nativeAudioTracks: videojs.browser.IS_IOS,
        nativeVideoTracks: videojs.browser.IS_IOS,
        vhs: {
            overrideNative: !videojs.browser.IS_ANY_SAFARI,
            limitRenditionByPlayerDimensions: false
        }
    }
};

export const seekButtonsOptions = {
    forward: 10,
    back: 10
};

export let vrOptions = {};
export let xrOptions = {};

export function initVROptions() {
    vrOptions = {
        projection: window.videoTypes[0],
        forceCardboard: true,
    };
    xrOptions = {
        projection: window.videoTypes[0],
        debug: true
    }
}

export const dashMediaPlayerSettings = {
    /*debug:  {
        logLevel: dashjs.Debug.LOG_LEVEL_DEBUG,
    },*/
    streaming: {
        abr: {
            autoSwitchBitrate: {audio: true, video: true},
            useBandwidthEstimation: true,},
        buffer: {
            preBufferAhead: true,
            bufferPruningInterval: 31,
            prefetchSegmentCount: 3,
            initialBufferLevel: 3,
            bufferTimeAtTopQuality: 10,
            bufferTimeAtTopQualityLongForm: 10,
            stableBufferTime: 10,
            longFormContentDurationThreshold: 600,
        },
        trackSwitchMode: {
            video: 'alwaysReplace'
        },
        selectionModeForInitialTrack: 'firstTrack',
        fastSwitchEnabled: true,
    }
};

//live dash settings
export const dashMediaPlayerLiveSettings = {
    streaming: {
        abr: {
            autoSwitchBitrate: { audio: true, video: true },
            useBandwidthEstimation: true,
        },
        buffer: {
            preBufferAhead: true,
            bufferPruningInterval: 4,    // ajusta o reduce
            prefetchSegmentCount: 2,      // probar con 2 para no adelantar demasiado
            initialBufferLevel: 2,        // 4 s al empezar
            bufferTimeAtTopQuality: 2,    // 6 s en calidades altas
            bufferTimeAtTopQualityLongForm: 2,
            stableBufferTime: 2,
            bufferToKeep: 2,
            longFormContentDurationThreshold: 600,
        },
        delay: {
            liveDelay: 3
        },
        liveCatchup: {
            enabled: true
        },
        trackSwitchMode: {
            video: 'alwaysReplace'
        },
        selectionModeForInitialTrack: 'firstTrack',
        fastSwitchEnabled: true,
    }
};

export const dashMediaPlayerSettingsSyncX = {
    /*debug:  {
        logLevel: dashjs.Debug.LOG_LEVEL_DEBUG,
    },*/
    "debug": {
        "logLevel": 0,
        "dispatchEvent": false
    },
    "streaming": {
        "abandonLoadTimeout": 10000,
        "wallclockTimeUpdateInterval": 100,
        "manifestUpdateRetryInterval": 100,
        "cacheInitSegments": false,
        "applyServiceDescription": true,
        "applyProducerReferenceTime": true,
        "applyContentSteering": true,
        "eventControllerRefreshDelay": 100,
        "enableManifestDurationMismatchFix": true,
        "parseInbandPrft": false,
        "enableManifestTimescaleMismatchFix": false,
        "capabilities": {
            "filterUnsupportedEssentialProperties": true,
            "useMediaCapabilitiesApi": false
        },
        "timeShiftBuffer": {
            "calcFromSegmentTimeline": false,
            "fallbackToSegmentTimeline": true
        },
        "metrics": {
            "maxListDepth": 100
        },
        "delay": {
            "liveDelayFragmentCount": null,
            "liveDelay": null,
            "useSuggestedPresentationDelay": true
        },
        "protection": {
            "keepProtectionMediaKeys": false,
            "ignoreEmeEncryptedEvent": false,
            "detectPlayreadyMessageFormat": true
        },
        "buffer": {
            "enableSeekDecorrelationFix": false,
            "fastSwitchEnabled": true,
            "flushBufferAtTrackSwitch": false,
            "reuseExistingSourceBuffers": true,
            "bufferPruningInterval": 10,
            "bufferToKeep": 3.52,
            "bufferTimeAtTopQuality": 12.672,
            "bufferTimeAtTopQualityLongForm": 12.672,
            "initialBufferLevel": 3,
            "stableBufferTime": 12,
            "longFormContentDurationThreshold": 600,
            "stallThreshold": 0.3,
            "useAppendWindow": true,
            "setStallState": true,
            "avoidCurrentTimeRangePruning": false,
            "useChangeTypeForTrackSwitch": true,
            "mediaSourceDurationInfinity": true,
            "resetSourceBuffersForTrackSwitch": false,
            "preBufferAhead": true,
            "prefetchSegmentCount": 3
        },
        "gaps": {
            "jumpGaps": true,
            "jumpLargeGaps": true,
            "smallGapLimit": 1.5,
            "threshold": 0.3,
            "enableSeekFix": true,
            "enableStallFix": false,
            "stallSeek": 0.1
        },
        "utcSynchronization": {
            "enabled": true,
            "useManifestDateHeaderTimeSource": true,
            "backgroundAttempts": 2,
            "timeBetweenSyncAttempts": 30,
            "maximumTimeBetweenSyncAttempts": 600,
            "minimumTimeBetweenSyncAttempts": 2,
            "timeBetweenSyncAttemptsAdjustmentFactor": 2,
            "maximumAllowedDrift": 100,
            "enableBackgroundSyncAfterSegmentDownloadError": true,
            "defaultTimingSource": {
                "scheme": "urn:mpeg:dash:utc:http-xsdate:2014",
                "value": "https://time.akamai.com/?iso&ms"
            }
        },
        "scheduling": {
            "defaultTimeout": 500,
            "lowLatencyTimeout": 0,
            "scheduleWhilePaused": true
        },
        "text": {
            "defaultEnabled": true,
            "extendSegmentedCues": true,
            "webvtt": {
                "customRenderingEnabled": false
            }
        },
        "liveCatchup": {
            "maxDrift": null,
            "playbackRate": {
                "min": null,
                "max": null
            },
            "playbackBufferMin": 0.5,
            "enabled": null,
            "mode": "liveCatchupModeDefault"
        },
        "lastBitrateCachingInfo": {
            "enabled": true,
            "ttl": 360000
        },
        "lastMediaSettingsCachingInfo": {
            "enabled": true,
            "ttl": 360000
        },
        "saveLastMediaSettingsForCurrentStreamingSession": true,
        "cacheLoadThresholds": {
            "video": 50,
            "audio": 5
        },
        "trackSwitchMode": {
            "audio": "alwaysReplace",
            "video": "alwaysReplace"
        },
        "selectionModeForInitialTrack": "highestSelectionPriority",
        "fragmentRequestTimeout": 20000,
        "fragmentRequestProgressTimeout": -1,
        "manifestRequestTimeout": 10000,
        "retryIntervals": {
            "MPD": 500,
            "XLinkExpansion": 500,
            "MediaSegment": 1000,
            "InitializationSegment": 1000,
            "BitstreamSwitchingSegment": 1000,
            "IndexSegment": 1000,
            "FragmentInfoSegment": 1000,
            "license": 1000,
            "other": 1000,
            "lowLatencyReductionFactor": 10
        },
        "retryAttempts": {
            "MPD": 3,
            "XLinkExpansion": 1,
            "MediaSegment": 3,
            "InitializationSegment": 3,
            "BitstreamSwitchingSegment": 3,
            "IndexSegment": 3,
            "FragmentInfoSegment": 3,
            "license": 3,
            "other": 3,
            "lowLatencyMultiplyFactor": 5
        }
    },
    "errors": {
        "recoverAttempts": {
            "mediaErrorDecode": 5
        }
    }
};